/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const EditorEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('EDITOR_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class EditorEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return EditorEnabledSettingParser.decode(input).map(res => new EditorEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return EditorEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EditorEnabledSettingParser.encode(data);
    }
    static schema() {
        return EditorEnabledSettingParser.schema();
    }
}
